/**
 * Created by daniel.gonzalez on 5/5/15.
 */

'use strict';

var SV = require('server-vars');
var FinancialAmount = require('bunsen/models/FinancialAmount');
var templates = require('../../templates/pdp/price');

var templateMap = {
    heroPrice: {
        soldSuspended: 'aboveFoldSoldSuspendedTmpl',
        recentlySoldHold: 'aboveFoldSoldHoldTmpl',
        priceUponRequest: 'aboveFoldPriceUponRequestTextTmpl',
        showPrice: 'aboveFoldPriceTmpl'
    },
    // only on old pdp
    detailsPrice: {
        soldSuspended: 'detailsSoldHoldTmpl',
        recentlySoldHold: 'detailsSoldHoldTmpl',
        priceUponRequest: 'detailsPriceUponRequestTmpl',
        showPrice: 'detailsPriceTmpl'
    },
    pdpPrint: {
        soldSuspended: 'pdpPrintIconTmpl',
        recentlySoldHold: 'pdpPrintIconTmpl',
        priceUponRequest: 'pdpPrintTmpl',
        showPrice: 'pdpPrintTmpl',
        netPrice: 'pdpPrintNetTmpl'
    }
};

var templateCopy = {
    soldSuspended: 'Sold',
    recentlySoldHold: 'On Hold',
    priceUponRequest: 'Price Upon Request'
};

var icons = {
    soldSuspended: 'is-sold',
    recentlySoldHold: 'is-on-hold'
};

var helpers = {
    SOLD: 'soldSuspended',
    HOLD: 'recentlySoldHold',
    UPON_REQUEST: 'priceUponRequest',
    SHOW_PRICE: 'showPrice'
};

/**
 * Gets the item's status: sold/suspended, recently sold/on hold, price upon request, or available with price
 * @param item
 * @returns {string} - constant corresponding to item's status
 */
helpers.getStatus = function (item) {
    var shouldShowSuspended = SV.get('data.isSuspended') || SV.get('data.isDeleted') || SV.get('data.isDealerSuspended');
    var status;

    if ((item.isSold() && SV.get('data.isSold')) || (!item.isAvailable() && shouldShowSuspended)) {
        // both of these conditions must stay combined together:
        // 1. (itemModel.isSold && SV.data.isSold)
        // 2. (itemModel.get('status.isAvailable') === 'N' && shouldShowSuspended)
        // If #2 uses an OR operator, then shit breaks and doesn't show the price
        // b/c for whatever reason, it seems like a lot of itemModel status.isAvailable === 'N'
        // even if they are on a category search page
        // Sold (using sold template) or suspended flow
        status = this.SOLD;
    } else if (item.isSold() || item.isOnHold()) {
        // On Hold, Recently Sold (i.e. not using sold template) flow
        status = this.HOLD;
    } else if (item.isPriceHidden() || item.getAmountIn(FinancialAmount.CURRENCY_USD) === 0) {
        // Price Upon Request flow
        status = this.UPON_REQUEST;
    } else {
        // Normal Price PDP
        status = this.SHOW_PRICE;
    }

    return status;
};

helpers.isShowPrice = function (status) {
    return status === this.SHOW_PRICE;
};

/**
 * Gets the template needed to show price on a view
 * @param view - view for which you need a template
 * @param status - status of item
 * @returns {Template}
 */
helpers.getTemplate = function (view, status) {
    var key = templateMap[view][status];
    return templates[key];
};

/**
 * @param id - template id
 * @returns {Template}
 */
helpers.getTemplateById = function (id) {
    return templates[id];
};

/**
 * Gets the copy to be shown in place of item's price
 * @param status - status of item
 * @returns {String}
 */
helpers.getTemplateCopy = function (status) {
    return templateCopy[status];
};

/**
 * Gets the icon to be shown next to copy
 * @param status - status of item
 * @returns {String}
 */
helpers.getIcon = function (status) {
    return icons[status];
};

module.exports = helpers;



//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/helpers/pdpPrice.js
// module id = 2581
// module chunks = 4